import React, { PropsWithChildren } from "react";
import { Box } from "@origin-digital/ods-core";

export const OuterBox: React.FC<PropsWithChildren> = ({ children }) => (
  <Box
    paddingTop={{
      lg: "xsmall",
      xs: "none",
    }}
    paddingBottom={{
      lg: "xsmall",
      xs: "xsmall",
    }}
    borderRadius="medium"
    backgroundColor="white"
    border="1px solid #e3e3e3"
    style={{
      width: 320,
    }}
    data-role="section"
    id="detail-template-sidebar-section"
  >
    {children}
  </Box>
);
